import React, { useEffect, useState } from 'react';
import {
    SimpleFormIterator,
    FormTab,
    TextField,
    ReferenceField,
    useRecordContext,
    FormDataConsumer,
    useGetMany,
    Loading,
    Link,
    useResourceContext
} from "react-admin";
import { Box, Typography, Divider, Chip } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import { ArrayInput, AutocompleteInput, RichTextInput, TextInput } from '../../../lib/wrappers/Inputs';
import { VersioningTypeInput } from "../../../lib/VersioningTypeInput";
var titleStyle = { color: "#AE223F" }
var labelStyle = {
    color: '#000000',
    opacity: 0.8,
    padding: 0,
    fontsize: 1,
    fontweight: 400, lineheight: 1, letterspacing: 0.00938
}

var record = [];
export const LearningOutcomesInputs = (source) => {
    const resource = useResourceContext();
    return <FormTab label="Learning and Teaching" {...source}>
        <Box flex={4} sx={{ paddingBottom: '20px' }}>
            <Typography variant="h6" style={titleStyle}>
                Course | <small><TextField source="id" label={false} /></small> | <small><TextField source="courseCode" label={false} /></small>
            </Typography>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Knowledge and Understanding" /></b></Divider>
            </Box>
        </Box>
        <ArrayInput source="learningOutcomes" label={false}>
            <SimpleFormIterator disableReordering fullWidth>
                <FormDataConsumer>
                    {({ getSource, scopedFormData }) => <Box display="flex" width={1}>
                        <Box flex={1}>
                            <TextInput source={getSource("id")} disabled />
                        </Box>
                        <Box flex={11} ml="0.5em">
                            <TextInput source={getSource("Title")} fullWidth multiline />
                        </Box>
                    </Box>}
                </FormDataConsumer>
            </SimpleFormIterator>
        </ArrayInput>

        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Intellectual Skills" /></b></Divider>
            </Box>
        </Box>
        <ArrayInput source="intellectualLearningOutcomes" label={false}>
            <SimpleFormIterator disableReordering fullWidth>
                <FormDataConsumer>
                    {({ getSource, scopedFormData }) => <Box display="flex" width={1}>
                        <Box flex={1}>
                            <TextInput source={getSource("id")} disabled />
                        </Box>
                        <Box flex={11} ml="0.5em">
                            <TextInput source={getSource("Title")} fullWidth multiline />
                        </Box>
                    </Box>}
                </FormDataConsumer>
            </SimpleFormIterator>
        </ArrayInput>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Professional/Vocational Skills" /></b></Divider>
            </Box>
        </Box>
        <ArrayInput source="professionalLearningOutcomes" label={false}>
            <SimpleFormIterator disableReordering fullWidth>
                <FormDataConsumer>
                    {({ getSource, scopedFormData }) => <Box display="flex" width={1}>
                        <Box flex={1}>
                            <TextInput source={getSource("id")} disabled />
                        </Box>
                        <Box flex={11} ml="0.5em">
                            <TextInput source={getSource("Title")} fullWidth multiline />
                        </Box>
                    </Box>}
                </FormDataConsumer>
            </SimpleFormIterator>
        </ArrayInput>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Key Skills" /></b></Divider>
            </Box>
        </Box>
        <ArrayInput source="keySkillLearningOutcomes" label={false}>
            <SimpleFormIterator disableReordering fullWidth>
                {/* <RichTextInput source="Title" label={false} fullWidth />  */}
                <FormDataConsumer>
                    {({ getSource, scopedFormData }) => <Box display="flex" width={1}>
                        <Box flex={1}>
                            <TextInput source={getSource("id")} disabled />
                        </Box>
                        <Box flex={11} ml="0.5em">
                            <TextInput source={getSource("description")} fullWidth multiline />
                        </Box>
                    </Box>}
                </FormDataConsumer>
            </SimpleFormIterator>
        </ArrayInput>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '5px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Learning And Teaching Methods" /></b></Divider>
            </Box>
        </Box>
        <RichTextInput source="learningAndTeachingDescription" label="" fullWidth />
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '5px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Graduate Attributes" /></b></Divider>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={2}>
                <TextInput source="GA1CommercialAwareness" fullWidth multiline />
                <TextInput source="GA2Communication" fullWidth multiline />
                <TextInput source="GA3Leadership" fullWidth multiline />
                <TextInput source="GA4InnovationEnterprise" fullWidth multiline />
                <TextInput source="GA5ProjectManagement" fullWidth multiline />
                <TextInput source="GA6DigitalLiteracy" fullWidth multiline />

            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '5px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Graduate Attribute Matrix / Learning Outcomes Matrix" /></b></Divider>
            </Box>
        </Box>
        <Box display="flex" width={1} sx={{ marginBottom: '40px' }}>
            <LearningAtributeMatrix />
        </Box>
        <Box display="flex" width={1}>
            <LearningOutcomesMatrix />
        </Box>
        <VersioningTypeInput source="versioningType" resource={resource} />
    </FormTab>;
}

const LearningAtributeMatrix = () => {
    const record = useRecordContext();
    let moduleIds = [];
    record?.moduleInfos?.forEach(module => {
        moduleIds.push(module.moduleId);
    });
    const { data, isLoading, error } = useGetMany(
        'Module',
        { ids: moduleIds }
    );
    if (isLoading) { return <Loading />; }
    if (error) { return <p>ERROR</p>; }
    return (
        <Box>
            <TableContainer component={Card}>
                <Table sx={{ minWidth: 1150 }} size="large" aria-label="">
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={8}>
                                <Typography variant="h6" style={titleStyle} gutterBottom>
                                    Graduate Attributes Matrix
                                </Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2} />
                            <TableCell colSpan={6} align="center">
                                Course Graduate Attributes
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Module Code</TableCell>
                            <TableCell>Module Title</TableCell>
                            <TableCell>GA1</TableCell>
                            <TableCell>GA2</TableCell>
                            <TableCell>GA3</TableCell>
                            <TableCell>GA4</TableCell>
                            <TableCell>GA5</TableCell>
                            <TableCell>GA6</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((mod, index) => (
                            <TableRow key={`${mod.moduleId}-${index}`}>
                                <TableCell>
                                    <Link to={"/Module/" + mod.id}>{mod.moduleCode}</Link>
                                </TableCell>
                                <TableCell>
                                    {mod.shortTitle}
                                </TableCell>
                                <TableCell>
                                    <AttributeCellRender module={mod} gaVal={1} />
                                </TableCell>
                                <TableCell>
                                    <AttributeCellRender module={mod} gaVal={2} />
                                </TableCell>
                                <TableCell>
                                    <AttributeCellRender module={mod} gaVal={3} />
                                </TableCell>
                                <TableCell>
                                    <AttributeCellRender module={mod} gaVal={4} />
                                </TableCell>
                                <TableCell>
                                    <AttributeCellRender module={mod} gaVal={5} />
                                </TableCell>
                                <TableCell>
                                    <AttributeCellRender module={mod} gaVal={6} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>

                </Table>
            </TableContainer>

        </Box>
    )
};

const LearningOutcomesMatrix = () => {
    const record = useRecordContext();
    const bool1 = true;
    if (!record) return null;

    let moduleInfos = [];
    let learningOutcomes = [];
    let intellectualLearningOutcomes = [];
    let professionalLearningOutcomes = [];
    let length = 0;
    if (record.moduleInfos) {
        moduleInfos = record.moduleInfos;
    }
    if (record.learningOutcomes) {
        learningOutcomes = record.learningOutcomes;
    }
    if (record.intellectualLearningOutcomes) {
        intellectualLearningOutcomes = record.intellectualLearningOutcomes;
    }
    if (record.professionalLearningOutcomes) {
        professionalLearningOutcomes = record.professionalLearningOutcomes;
    }
    length = length + learningOutcomes.length;
    length = length + intellectualLearningOutcomes.length;
    length = length + professionalLearningOutcomes.length;
    if (!record.OutcomesMatrixs) {
        record.OutcomesMatrixs = [];
    }
    return (
        <Box>
            <TableContainer component={Card}>
                <Table sx={{ minWidth: 1150 }} size="large" aria-label="">
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={3 + length}>
                                <Typography variant="h6" style={titleStyle} gutterBottom>
                                    Learning Outcomes Matrix
                                </Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={3}>

                            </TableCell>
                            <TableCell colSpan={length} align="center">
                                Course Learning Outcomes
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Module Code</TableCell>
                            <TableCell>Module Title</TableCell>
                            <TableCell>C / S / O</TableCell>
                            {
                                learningOutcomes.map((learningOutcome, index) => {
                                    return (
                                        <TableCell key={`${learningOutcome.id}-${index}`}>
                                            {learningOutcome.id}
                                        </TableCell>
                                    );
                                })}
                            {
                                professionalLearningOutcomes.map((learningOutcome, index) => {
                                    return (
                                        <TableCell key={`${learningOutcome.id}-${index}`}>
                                            {learningOutcome.id}
                                        </TableCell>
                                    );
                                })}
                            {
                                intellectualLearningOutcomes.map((learningOutcome, index) => {
                                    return (
                                        <TableCell key={`${learningOutcome.id}-${index}`}>
                                            {learningOutcome.id}
                                        </TableCell>
                                    );
                                })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {moduleInfos.map((module, index) => {
                            Object.assign(record, { [`moduleId${module.moduleId}`]: module.moduleId })
                            return (
                                <TableRow key={`${module.moduleId}-${index}`}>
                                    <TableCell>
                                        <ReferenceField reference="Module" source={"moduleId" + module.moduleId}>
                                            <TextField source="moduleCode" />
                                        </ReferenceField>
                                    </TableCell>
                                    <TableCell>
                                        <ReferenceField reference="Module" source={"moduleId" + module.moduleId} link={false}>
                                            <TextField source="shortTitle" />
                                        </ReferenceField>
                                    </TableCell>
                                    <TableCell>
                                        {module.type}
                                    </TableCell>
                                    {
                                        learningOutcomes.map((learningOutcome, index) => {
                                            return (
                                                <TableCell key={`${module.moduleId}-${index}`} >
                                                    <CellRender module={module} learningOutcome={learningOutcome} />
                                                </TableCell>
                                            );
                                        })
                                    }
                                    {
                                        professionalLearningOutcomes.map((learningOutcome, index) => {
                                            return (
                                                <TableCell key={`${module.moduleId}-${index}`} >
                                                    <CellRender module={module} learningOutcome={learningOutcome} />
                                                </TableCell>
                                            );
                                        })}
                                    {
                                        intellectualLearningOutcomes.map((learningOutcome, index) => {
                                            return (
                                                <TableCell key={`${module.moduleId}-${index}`}>
                                                    <CellRender module={module} learningOutcome={learningOutcome} />
                                                </TableCell>
                                            );
                                        })}
                                </TableRow>

                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
};

const CellRender = ({ module, learningOutcome, }) => {
    if (module.learnningOutcomes?.includes(learningOutcome.id)) {
        return (<span>&#10004;</span>)
    }
    else {
        return (<span>-</span>)
    }
};

const AttributeCellRender = ({ module, gaVal }) => {
    switch (gaVal) {
        case 1:
            if (module.gA1CommercialAwareness) {
                return (<span>&#10004;</span>);
            }
            else {
                return "-";
            }
            break;
        case 2:
            if (module.gA2Communication) {
                return (<span>&#10004;</span>);
            }
            else {
                return "-";
            }
            break;
        case 3:
            if (module.gA3Leadership) {
                return (<span>&#10004;</span>);
            }
            else {
                return "-";
            }
            break;
        case 4:
            if (module.gA4InnovationandEnt) {
                return (<span>&#10004;</span>);
            }
            else {
                return "-";
            }
            break;
        case 5:
            if (module.gA5ProjectManagement) {
                return (<span>&#10004;</span>);
            }
            else {
                return "-";
            }
            break;
        case 6:
            if (module.gA6DigitalLiteracy) {
                return (<span>&#10004;</span>);
            }
            else {
                return "-";
            }
            break;
        default:
            return "-";
    }
};
